<script>
export default {
  name: "IconCookie"
};
</script>

<template>
  <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill="currentColor" fill-rule="nonzero">
      <path
        d="M0 9.5003C0 6.9235 1.0086 4.512 2.842 2.7095 4.6606.9212 7.064-.0406 9.61.0013a.7925.7925 0 0 1 .5083.1963c.1211.1061.2153.2526.255.4085.1765.7006.649 1.2928 1.2967 1.6269a.7923.7923 0 0 1 .3776.9848c-.6634 1.748.6705 3.4135 2.3512 3.4135l.141-.015.1322-.0174a.791.791 0 0 1 .6032.1892.795.795 0 0 1 .2723.5708c.0388 1.1344.8329 2.1081 1.931 2.3678.8462.2003 1.368 1.071 1.1676 1.9427C17.6423 15.9854 13.8613 19 9.451 19 4.2394 19 0 14.7386 0 9.5003ZM9.0393 1.594c-1.9143.0982-3.7043.8835-5.0873 2.2443C2.424 5.341 1.5833 7.3517 1.5833 9.5003c0 4.365 3.5293 7.9164 7.8676 7.9164 3.6702 0 6.817-2.511 7.653-6.106l-.0102-.053c-1.5121-.353-2.6774-1.5611-3.0242-3.0565-2.1122-.1686-3.7778-1.9403-3.7778-4.0936 0-.2716.0293-.5447.087-.8178a4.1303 4.1303 0 0 1-1.3394-1.6957Z"
        stroke="currentColor"
        stroke-width=".7"
      />
      <circle transform="rotate(90 11.9583 11.7919)" cx="11.9583" cy="11.7919" r="1.5" />
      <circle transform="rotate(90 6.8333 6.2504)" cx="6.8333" cy="6.2504" r="1.5" />
      <circle transform="rotate(90 6.25 11.9585)" cx="6.25" cy="11.9585" r="1.5" />
    </g>
  </svg>
</template>
